import { CampagneDto, CampagneProjection, useGetCampagneByAnneeQuery } from '@common/services';
import { useState } from 'react';
import { useCurrentCampagne } from './use-campagne.hook';

export const useSelectedCampagne = (projection = CampagneProjection.DEFAULT) => {
  const { campagne: currentCampagne } = useCurrentCampagne();

  const [selectedYear, setSelectedYear] = useState<number | null>(null);

  const { data: selectedCampagne } = useGetCampagneByAnneeQuery(
    { year: selectedYear, projection },
    { skip: !selectedYear },
  );

  return {
    selectedCampagne: selectedCampagne ?? currentCampagne satisfies CampagneDto | undefined,
    setSelectedCampagneYear: setSelectedYear,
  };
};